import React, {useEffect, useState} from 'react';
import Introduction from './Introduction/Introduction';
import PopularPosts from './PopularPosts/PopularPosts';
import Content from './Content/Content';
import {Grid} from "@mui/material";
import UpcomingEvents from "./UpcomingEvents/UpcomingEvents";
import PopularWriters from "./PopularWriters/PopularWriters";
import Categories from "./CategorySection/Categories";
import AboutUs from "./AboutUs/AboutUs";
import '../../style/homepage/homepage.scss';
import axios from "../../config/axios";

function Mainpage() {

    //Axios fetching to the backend
    const [fetchedPosts, setPosts] = useState([]);
    const [fetchedPostsData, setPostsData] = useState([]);
    const [fetchedUsers, setUsers] = useState([]);
    const [fetchedRoles, setRoles] = useState([]);
    const [fetchedThumbnails, setThumbnails] = useState([]);
    const [fetchedEvents, setEvents] = useState([]);
    const [fetchedEventThumbnails, setEventThumbnails] = useState({});
    const [fetchedCategories, setCategories] = useState([]);
    const [fetchedPostCategories, setPostCategories] = useState({}); // Maps postId -> categories array
    const [axiosProfiles, setAxiosProfiles] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const LIMIT = 10;
    
    //Is Axios currently fetching to the backend?
    const [isUsersLoading, setUsersLoading] = useState(true);
    const [isRolesLoading, setRolesLoading] = useState(true);
    const [isPostsDataLoading, setPostsDataLoading] = useState(true);
    const [isThumbnailsLoading, setThumbnailsLoading] = useState(true);
    const [isEventsLoading, setEventsLoading] = useState(true);
    const [isCategoriesLoading, setCategoriesLoading] = useState(true);
    const [isLoading, setLoading] = useState(true);

    //Post related
    const [tag, setTag] = useState(null);
    //const [capturedHeaders, setHeaders] = useState();

    const [sortBy, setSortBy] = useState('followed_user'); // Sorting state
    const [follows, setFollows] = useState([]);

    const fetchFollows = async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            if (user?.id) {
                // Using axios instance which already has baseURL and token interceptor configured
                const response = await axios.get(`/follow/${user.id}/following`);
                console.log("Fetched follows:", response.data);
                setFollows(response.data || []);
            } else {
                console.warn("User ID not found in localStorage.");
                setFollows([]);
            }
        } catch (error) {
            console.error("Error fetching followed users:", error);
            setFollows([]);
        }
    };

    // Monitor follows state change
    useEffect(() => {
        console.log("Updated Follows:", follows);
    }, [follows]);

    // replaces the 3 post axios calls inside updateTime
    const fetchPosts = (pageNum) => {
        setLoading(true);
        axios.get(`/post?page=${pageNum}&limit=${LIMIT}`)
            .then((response) => {
                // Ensure posts is always an array
                let posts = Array.isArray(response.data) ? response.data : [];

                // Sort the posts based on the sortBy state
                if (sortBy === 'date') {
                    console.log("posts", posts);
                    // Sort by dateCreated (newest first)
                    posts.sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

                } else if (sortBy === 'followed_user') {
                    // Sort by followed users (posts by followed users first)
                    // Extract followed user IDs from follows array (which contains objects with followed_id)
                    const followedUserIds = Array.isArray(follows)
                        ? follows.map(f => f.followed_id)
                        : [];
                    posts.sort((a, b) => {
                        const aIsFollowed = followedUserIds.includes(a.userId);
                        const bIsFollowed = followedUserIds.includes(b.userId);
                        return (aIsFollowed === bIsFollowed) ? 0 : aIsFollowed ? -1 : 1;
                    });
                }

                // Page 1 = replace, page 2+ = append
                if (pageNum === 1) {
                    setPosts(posts);
                } else {
                    setPosts(prev => [...prev, ...posts]);
                }
                setHasMore(posts.length === LIMIT);
                setLoading(false);

                // Fetch body data for this page's posts
                const dataPromises = posts.map(post =>
                    axios.get(`/post/${post.id}/data`)
                        .then(r => r.data)
                        .catch(() => null)
                );
                Promise.all(dataPromises).then(dataArray => {
                    if (pageNum === 1) setPostsData(dataArray);
                    else setPostsData(prev => [...prev, ...dataArray]);
                    setPostsDataLoading(false);
                });

                // Fetch thumbnails for this page's posts
                const thumbPromises = posts.map(post =>
                    post.thumbnail
                        ? axios.get(`/post/${post.id}/thumbnail`, { responseType: 'blob' })
                            .then(r => URL.createObjectURL(r.data))
                            .catch(() => null)
                        : Promise.resolve(null)
                );
                Promise.all(thumbPromises).then(thumbArray => {
                    if (pageNum === 1) setThumbnails(thumbArray);
                    else setThumbnails(prev => [...prev, ...thumbArray]);
                    setThumbnailsLoading(false);
                });

                // Fetch categories for each post
                const categoryPromises = posts.map(post =>
                    axios.get(`/post/category/${post.id}`)
                        .then(r => ({ postId: post.id, categories: r.data }))
                        .catch(() => ({ postId: post.id, categories: [] }))
                );
                Promise.all(categoryPromises).then(catArray => {
                    const catMap = {};
                    catArray.forEach(item => {
                        catMap[item.postId] = item.categories;
                    });
                    if (pageNum === 1) setPostCategories(catMap);
                    else setPostCategories(prev => ({ ...prev, ...catMap }));
                });

            })
            .catch(error => {
                console.error('Error fetching posts:', error);
                setLoading(false);
            });

    };

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchPosts(nextPage);
    };

    // updateTime now only handles non-post fetches
    const updateTime = () => {
        //Axios Users
        axios.get(`/user`)
            .then((response) => {
                const users = Array.isArray(response.data) ? response.data : [];
                setUsers(users);
                setUsersLoading(false)
                //console.log('Fetched Users ', users);
                let userRoles = users.map(user => {
                    return axios.get(`/user/${user.id}/role`)
                        .then(response => response.data)
                        .catch(error => {
                            console.error(error);
                        })
                })
                return Promise.all(userRoles);
            })
            .then(userRolesArray => {
                setRoles(userRolesArray);
                setRolesLoading(false);
                console.log('Fetched User Roles = ', userRolesArray);
            })
            .catch(error => {
                console.error(error);
            });

        //Axios Events
        axios.get('/event')
            .then((response) => {
                const events = Array.isArray(response.data) ? response.data : [];
                setEvents(events);
                setEventsLoading(false);
                //console.log('Fetched Events ', events);

                // Fetch thumbnails for each event
                events.forEach(event => {
                    axios.get(`/event/thumbnail/${event.id}`, {
                        responseType: 'blob'
                    })
                    .then(thumbResponse => {
                        const thumbnailUrl = URL.createObjectURL(thumbResponse.data);
                        setEventThumbnails(prev => ({
                            ...prev,
                            [event.id]: thumbnailUrl
                        }));
                    })
                    .catch(error => {
                        console.error('Error fetching event thumbnail:', error);
                    });
                });
            })
            .catch(error => {
                console.error(error);
                setEvents([]);
                setEventsLoading(false);
            });

        //Axios Category for Posts
        axios.get(`/category/post`)
            .then((response) => {
                const categories = Array.isArray(response.data) ? response.data : [];
                setCategories(categories);
                setCategoriesLoading(false);
                console.log('Fetched Categories ', categories);
            })
            .catch(error => {
                console.error(error);
                setCategories([]);
                setCategoriesLoading(false);
            });

        //Axios Profiles for Posts
        axios.get(`/profile`)
        .then((response) => {
            const profileData = response.data.profiles || response.data;
            setAxiosProfiles(Array.isArray(profileData) ? profileData : []);
        })
        .catch(error => {
            console.error('profiles error:', error);
            setAxiosProfiles([]);
        });

        setLoading(false);
    };

    useEffect(() => {
        console.log('Updated Fetched Posts:', fetchedPosts);
        console.log("url:" + process.env.REACT_APP_API_ENDPOINT);
    }, [fetchedPosts]);

    useEffect(() => {
        fetchFollows();
        fetchPosts(1);   // initial post load
        updateTime(); // Update or re-sort posts when sortBy changes
        // Keep the hourly refresh for non-post data
        const interval = setInterval(() => {
            updateTime();
        }, 1000 * 60 * 60);

        return () => {
            clearInterval(interval);
        }

    }, []);

    // Re-fetch from page 1 when sort changes
    useEffect(() => {
        setPage(1);
        setHasMore(true);
        fetchPosts(1);
    }, [sortBy]); // Runs whenever `sortBy` changes

    const handlePostDelete = (postId) => {
        setPosts(prev => prev.filter(p => p.id !== postId));
    };

    return (
        <React.Fragment>
            <div className={'contentContainer'}>
                {/* Main Content Grid */}
                <Grid container spacing={4} justifyContent={'center'}>
                    {/* Posts Column */}
                    <Grid item xs={12} md={8} lg={8}>
                        <Content axiosPosts={fetchedPosts} axiosPostsData={fetchedPostsData}
                                 axiosThumbnails={fetchedThumbnails} axiosUsersRoles={fetchedRoles}
                                 loading={isLoading} usersrolesLoading={isRolesLoading}
                                 postsDataLoading={isPostsDataLoading} thumbnailsLoading={isThumbnailsLoading}
                                 tag={tag} axiosCategories={fetchedCategories} isSwitchOn={sortBy === 'followed_user'}
                                 onPostDelete={handlePostDelete}
                                 axiosProfiles={axiosProfiles}
                                 follows={follows}
                                 hasMore={hasMore}
                                 onLoadMore={handleLoadMore}
                                 postCategories={fetchedPostCategories}
                                 sortBy={sortBy}
                                 setSortBy={setSortBy}
                        />
                    </Grid>

                    {/* Sidebar Column */}
                    <Grid item xs={12} md={4} lg={4}>
                        <div className={'sideContent'}>
                            <div className={'sidebarSection'}>
                                <UpcomingEvents axiosEvents={fetchedEvents} loading={isLoading}
                                                eventsLoading={isEventsLoading}
                                                eventThumbnails={fetchedEventThumbnails}/>
                            </div>
                            <div className={'sidebarSection'}>
                                <PopularWriters axiosUsersRoles={fetchedRoles} axiosPosts={fetchedPosts}
                                                loading={isLoading} usersrolesLoading={isRolesLoading} axiosProfiles={axiosProfiles}/>
                            </div>
                            <div className={'sidebarSection'}>
                                <Categories tag={tag} setTag={setTag} axiosCategories={fetchedCategories}
                                            categoriesLoading={isCategoriesLoading} loading={isLoading}/>
                            </div>
                            <div className={'sidebarSection'}>
                                <AboutUs/>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
    )
}

export default Mainpage
